import { Component, Input, AfterViewInit, OnInit } from '@angular/core';
import { ArgyleIncomeStream } from 'src/app/models/Argyle';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { GroupApplicantsService } from 'src/app/services/group-applicants.service';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { resourceLimits } from 'worker_threads';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-paystub-upload',
  templateUrl: './paystub-upload.component.html',
  styleUrls: ['./paystub-upload.component.less']
})
export class PaystubUploadComponent implements AfterViewInit, OnInit{
  @Input() stream :ArgyleIncomeStream;
  overlays : any[];
  urlToUse : SafeUrl; 
  activeId : number;
  loading: boolean = false;
  constructor(public modalService: NgbModal,public fileDownload: FileDownloadService, private toast: ToastrService, private auth: AuthService, public appData: ApplicantDataService,private sanitizer : DomSanitizer,private http: HttpClient,public groups: GroupApplicantsService) { }
  ngOnInit(): void {
    this.activeId = this.stream.historicalData[0].recordId;
  }
  ngAfterViewInit(): void {
    console.log(this.stream);

    // this.activeId = this.stream.historicalData[0].reportId;
    // if(this.stream.historicalData[0].metadata.ocr_authenticity.doc_analysis[0].form_analysis[0].visualizations[0].page_visualizations &&
    //   this.stream.historicalData[0].metadata.ocr_authenticity.doc_analysis[0].form_analysis[0].visualizations[0].page_visualizations.length > 0)
    //   {
    //     this.appData.GetOverlayList(this.stream.recordId).subscribe((res : any[])=>{
    //       this.overlays = res;
    //       console.log(this.overlays);
    //     })
    //   }
  }

  clearReport()
  {
    this.urlToUse = null;
  }

  setOverlay(i : any, ovr: any)
  {
    this.loading = true;
    this.urlToUse = null;
    this.appData.downloadOverlayProxy(ovr.image_url)
    .subscribe(blob => {
      const url = URL.createObjectURL(blob);
      this.urlToUse = this.sanitizer.bypassSecurityTrustUrl(url);
      this.loading = false;
    });
  }

  download(i : any, docType: number)
  {
    this.appData.DownloadArgyleDoc(i.parsed.id,i.parsed.file_name, this.stream.inviteId, docType ).subscribe(res=>{
      this.fileDownload.HandleFileDownload(res, 'pdf', i.parsed.file_name);
    })
  }
}
